import _snakeCase from 'lodash/snakeCase';
import {ProductFilterOptionModel} from '../product-filter/product-filter.model';
import {PRODUCT_LANGUAGE} from './../../core/language/product-languages';
import { FendiProvider } from '../../core/external-provider/external-provider';

export default class ProductDetailController {
  /* @ngInject */
  constructor(RouterService, ProductService, CommunicationToolService, CarouselService, PRODUCT_CONSTANT, ModalFactory, AuthService, $scope, MediaQueryService, BreadcrumbService, DeviceService, $sce) {
    this.routerService = RouterService;
    this.productService = ProductService;
    this.carouselService = CarouselService;
    this.communicationToolService = CommunicationToolService;
    this.breadcrumbService = BreadcrumbService;
    this.modalFactory = ModalFactory;
    this.authService = AuthService;
    this.mediaQueryService = MediaQueryService;
    this.PRODUCT_CONSTANT = PRODUCT_CONSTANT;
    this.deviceService = DeviceService;
    this.$scope = $scope;
    this.$sce = $sce;
    this.onClickProductImage = this.onClickProductImage.bind(this);
    this.onCarouselSwipe = this.onCarouselSwipe.bind(this);
    this.onBreadcrumbClick = this.onBreadcrumbClick.bind(this);
    this.goToRelated = this.goToRelated.bind(this);
    this.goToDetail = this.goToDetail.bind(this);
  }

  $onInit() {
    document.documentElement.scrollTop = 0;
    const {id} = this.routerService.state.params;
    this.isIOS = this.deviceService.isIOS();
    this.listenMediaQuery();
    this.images = [];
    // this.isPersonalShopper = this.authService.isPersonalShopper();
    this.productService.get(id).then(product => this.onProductReady(product));
    this.productService.variations(id).then(variations => this.onVariationsReady(variations));
    this.productService.getProductDistribution(id).then(markets => this.onDistributionsReady(markets));
    this.communicationToolService.relatedToProduct(id).then(data => this.onCommunicationToolRelatedReady(data));
  }

  onProductReady(product) {
    this.product = product;
    this.images = this.product.images;
    this.season = ProductFilterOptionModel.formatSeasonLabel(this.product.seasonId);
    this.activeCarousel = this.getCarousel(this.images[0]);
    this.breadcrumbs = [
      {id: product.genderId, value: product.gender, filter: 'gender'},
      {id: product.categoryId, value: product.category, filter: 'category'},
      {id: product.typeId, value: product.type, filter: 'type'},
    ];

    const availableLanguageKeys = this.product.getTranslationLanguageKeys(FendiProvider.ECOMMERCE);
    this.availableOptions = PRODUCT_LANGUAGE.filter(l => availableLanguageKeys.includes(l.id));
    this.activeLanguage = PRODUCT_LANGUAGE[0];
  }

  onVariationsReady(variations) {
    const images = variations.map(v => v.coverImage.url);
    this.variations = variations;
    this.variationsImages = images;
    this.hasMoreVariationsImages = images.filter(i => i).length < images.length;
  }

  onDistributionsReady(markets) {
    this.distributionNames = markets.map(d => d.name).join(', ');
  }

  onCommunicationToolRelatedReady(communicationTools) {
    const images = communicationTools.map(v => v.cover.url);
    this.communicationTools = communicationTools;
    this.hasMoreCommunicationToolsImages = images.filter(i => i).length < images.length;
    this.communicationToolsImages = images;
  }

  goToRelated(relatedType) {
    return () => {
      this.routerService.state.go('productRelated', {
        id: this.product.id,
        gender: this.product.gender.toLowerCase(),
        type: relatedType,
      });
    };
  }

  goToDetail(stateName) {
    return (item) => {
      const isProduct = stateName === 'product';
      const params = isProduct
        ? {id: item.id, gender: item.gender.value.toLowerCase()}
        : {categoryId: item.category.id, collectionId: item.collection.id, itemId: item.id};
      this.routerService.state.go(stateName, params);
    };
  }

  goToCheck(checkType) {
    this.routerService.state.go('productCheck', {
      id: this.product.id,
      gender: this.product.gender.toLowerCase(),
      type: checkType,
    });
  }

  showModalZoomImage() {
    this.modalFactory.showZoomImage({
      images: this.images,
      activeImage: this.activeCarousel.imagePicture,
    }).then((modal) => {
      modal.close.then(({activeImage}) => {
        this.onClickProductImage(activeImage, {slideTime: 0});
      });
    });
  }

  openEnvironmentalInfoModal() {
    const environmentalInfoLink = this.product.environmentalInfoLink;
    this.modalFactory.showIframeModal({iframeLink: environmentalInfoLink, title: ''});
  }

  onCarouselSwipe({activeIndex}) {
    this.activeCarousel = this.getCarousel(this.images[activeIndex]);
    this.$scope.$applyAsync();
  }

  onClickProductImage(clickedImage, {slideTime} = {}) {
    this.activeCarousel = this.getCarousel(clickedImage);
    this.activeCarousel.instance.slideTo(this.activeCarousel.imageIndex, slideTime);
    this.$scope.$applyAsync();
  }

  getCarousel(newImage) {
    const carousel = this.carouselService.get('product-images');
    const index = this.images.findIndex(img => img.url === newImage.url);
    return {
      imageIndex: index,
      imagePicture: this.images[index],
      instance: carousel,
    };
  }

  listenMediaQuery() {
    this.isTablet = this.mediaQueryService.is('tablet');
    this.mediaQueryService.on('tablet', match => this.isTablet = match);
    this.isDesktop = this.mediaQueryService.is('desktop');
    this.mediaQueryService.on('desktop', match => this.isDesktop = match);
  }

  saveImage() {
    const fileUrl = this.activeCarousel.imagePicture.url;
    const name = _snakeCase(this.product.getTranslatedName());
    const id = this.product.id;
    const urlToOpen = this.isIOS ? fileUrl : `/dl.php?downloadFile=${encodeURI(fileUrl)}&fileName=${name}-${id}.jpg`;
    window.open(urlToOpen);
  }

  onBreadcrumbClick(items, item) {
    const params = this.breadcrumbService.createFilterParams(items, item);
    this.routerService.state.go('products', params);
  }

  isLaunchDateVisible() {
    const YEARS_TO_ADD = 5;
    const today = new Date();
    const launchDate = new Date(this.product.launchDate);
    const visibleLaunchDateLimit = new Date();
    visibleLaunchDateLimit.setFullYear(today.getFullYear() + YEARS_TO_ADD);
    return launchDate <= visibleLaunchDateLimit;
  }
}



// WEBPACK FOOTER //
// ./src/app/product/product-detail/product-detail.controller.js